import { gql } from "@apollo/client";

import assessmentCalibrationQuestionFragment from "./assessment-calibration-question-fragment";

export default gql`
  ${assessmentCalibrationQuestionFragment}
  fragment CalibrationNode on AssessmentAnswerCalibrationInterface {
    id
    comment
    creator {
      id
      name
      avatar
    }
    target {
      id
    }
    created
    isSuggestion
    isPrecalibration
    answerId
    question {
      ...AssessmentCalibrationQuestion
    }
    ... on RangeAssessmentAnswerCalibrationNode {
      integerAnswer
      prevIntegerAnswer
    }
    ... on TalentIndicatorAssessmentAnswerCalibrationNode {
      integerAnswer
      prevIntegerAnswer
    }
  }
`;
